<template>
  <div class="py-4 px-4 sm:px-6">
    <slot />
  </div>
</template>
